import React, { useState, useEffect } from 'react';
import MainInterface from './components/MainInterface';

function App() {
  // const [message, setMessage] = useState('');

  // useEffect(() => {
  //   // fetch('http://localhost:5000/api/data')
  //   fetch('/api/data')
  //     .then(response => response.json())
  //     .then(data => setMessage(data.message));
  // }, []);

  return (
    <div>
      <MainInterface />
    </div>
  );
}

export default App;